import React from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import { Area } from "../../../models/Area";
import { CalendarEvent } from "../../../models/CalendarEvent";
import { Delivery } from "../../../models/Delivery";
import { Equipment } from "../../../models/Equipment";
import Modal from "../Modal";
import ShareProjectItemBody from "./shareProjectItemBody";

interface Props {
    showModal: boolean;
    hideModal: () => void;
    shareType: "location" | "project" | "delivery" | "equipment";
    projectToken: string;
    // Optional props
    currentObject?: Area | Equipment;
    calendarEvent?: CalendarEvent;
    delivery?: Delivery;
}

const ShareProjectItemModal: React.FC<Props> = ({
    showModal,
    hideModal,
    currentObject,
    calendarEvent,
    delivery,
    shareType,
    projectToken,
}) => {
    const globalStoreContext = React.useContext(GlobalStoreContext);

    if (["location", "equipment"].includes(shareType) && !currentObject) {
        return <></>;
    }

    const itemLabel = () => {
        switch (shareType) {
            case "location":
                return currentObject?.areaName || currentObject?.equipmentName || "Location";
            case "equipment":
                return currentObject?.equipmentName || "Equipment";
            case "project":
                return globalStoreContext.currentProjectInfo.project_name;
            case "delivery":
                return calendarEvent?.name || "Delivery";
        }
    };

    return (
        <Modal
            destroyOnHidden={true}
            title={`Share ${itemLabel()}`}
            open={showModal}
            onCancel={hideModal}
            onClose={hideModal}
            width={"50vw"}
            footer={null}
        >
            <ShareProjectItemBody
                shareType={shareType}
                projectToken={projectToken}
                currentObject={currentObject}
                calendarEvent={calendarEvent}
                delivery={delivery}
                onFinish={hideModal}
            />
        </Modal>
    );
};

export default ShareProjectItemModal;
